
import redirectInterceptor from "@/interceptors/redirect_interceptor";
import HttpError from "../http_error";
export default class FleetService {
  constructor(baseUrl, fleetDataFromJsonMapper, infoDataFromJsonMapper) {
    this.baseUrl = baseUrl;
    this.fleetDataFromJsonMapper = fleetDataFromJsonMapper;
    this.infoDataFromJsonMapper = infoDataFromJsonMapper;
  }

  async fetchFleet(accessToken) {
    const url = `${this.baseUrl}/vesselperformance/fleet`;
    const response = await redirectInterceptor.get(url, {
      headers: {
        Authorization: `${accessToken}`
      }
    });
    if (response.data.success) {
      return response.data.data.map(this.fleetDataFromJsonMapper);
    }
    throw new HttpError("Failed to fetch fleet data", response.status);
  }
  async fetchVesselIdlePeriods(accessToken, payload) {
    const url = `${this.baseUrl}/vesselperformance/fleet/idle-periods`;

    const response = await redirectInterceptor.post(url, payload, {
      headers: {
        Authorization: `${accessToken}`
      }
    });

    if (response.data.success) {
      return response.data.data;
    }

    throw new Error("Failed to fetch idle periods");
  }

}

/*

async fetchInfoDetails(accessToken) {

        const url = `${this.baseUrl}/vesselperformance/fleet/infoDetails`

        const response = await redirectInterceptor.get(url, {
            headers: {
                Authorization: `${accessToken}`
            }
        })
        if (response.data.success) {
            let returnObj = Object.fromEntries(
                response.data.data.
                    map(this.infoDataFromJsonMapper).
                    map(obj => [obj['location'], obj])
            )
            return returnObj
        }
        throw new HttpError('Failed to fetch info details', response.status)
    }

*/
